import(/* webpackMode: "eager", webpackExports: ["FeaturesContent"] */ "/app/components/marketing/features-content.tsx");
